/* eslint-disable */
export class Conf {
  static idempiereUrl = "https://id.effecitech.com/";

  static windowTitle = "Effecitech Reg Ore";

  static buildNo = "2026-02-26_174824"

}
